<app-shortcut-button-new 
                         [controls]="filterControls()"
                         [activeShortcut]="activeShortcut$ | async"
                        [dateOption]="shortcutButtonService.dateOption$ | async"
                        *ngIf="shortcutButtonService.filterEnables && !shortcutButtonService.filterEnables.hideShortcut" 

></app-shortcut-button-new>
